import { StudentSettingName } from '../enums/student-settings.enum';

export class StudentSettingPayload {
  value: string;

  constructor(studentSettingName: StudentSettingName, value: any) {
    if (
      studentSettingName === StudentSettingName.FOLLOW_MODE ||
      studentSettingName === StudentSettingName.SITE_COLOR_SCHEME ||
      studentSettingName === StudentSettingName.ANCHORING_FORGETTING_INDEX
    ) {
      this.value = value;
    } else if (studentSettingName === StudentSettingName.DAILY_LIMIT_REPETITIONS) {
      this.value = Number(value).toString();
    } else {
      this.value = value === true ? 'true' : 'false';
    }
  }
}
